import { render, staticRenderFns } from "./AccidentManage.vue?vue&type=template&id=008a7d87&scoped=true&"
import script from "./AccidentManage.vue?vue&type=script&lang=js&"
export * from "./AccidentManage.vue?vue&type=script&lang=js&"
import style0 from "./AccidentManage.vue?vue&type=style&index=0&id=008a7d87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008a7d87",
  null
  
)

export default component.exports